<template>
  <div class="center">
    <!-- <h1>
      {{ this.$parent.$parent.$children[0].pageType }}-公告基本信息-{{
        this.$parent.$parent.$children[0].rowData.NoticeName
      }}
    </h1> -->

    <!-- 添加表单 -->
    <el-form
      v-if="this.$parent.$parent.$children[0].pageType === 'add'"
      :model="formLabelAlign"
      ref="formLabelAlign"
      :rules="rules"
      label-width="80px"
      :inline="false"
      size="normal"
      :label-position="labelPosition"
    >
      <el-form-item label="公告名称：" prop="NoticeName">
        <el-input
          v-model.trim="formLabelAlign.NoticeName"
          placeholder="请输入公告名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="公告开放时间：" prop="OpenTime">
        <el-date-picker
          v-model="formLabelAlign.OpenTime"
          type="datetimerange"
          :picker-options="pickerOptions0"
          range-separator="至"
          start-placeholder="公告开始日期"
          end-placeholder="公告结束日期"
          @focus="obtainTime"
          :default-time="[vehicleTime, '23:59:59']"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="公告内容：" prop="NoticeContent">
        <el-input
          v-model.trim="formLabelAlign.NoticeContent"
          type="textarea"
          placeholder="请输入内容"
        ></el-input>
      </el-form-item>
    </el-form>

    <!-- 查看详情 -->
    <div
      v-if="this.$parent.$parent.$children[0].pageType === 'detail'"
      class="info_box"
    >
      <p class="info_line">
        <span>公告名称：</span>
        <span>{{ getData.NoticeName }}</span>
      </p>

      <p class="info_line">
        <span>公告开放时间：</span>
        <span>{{
          getData.BeginTime != null && getData.EndTime != null
            ? $moment(getData.BeginTime).format("YYYY/MM/DD HH:mm") +
              " - " +
              $moment(getData.EndTime).format("YYYY/MM/DD HH:mm")
            : null
        }}</span>
      </p>

      <p class="info_line">
        <span>公告内容：</span>
        <span>{{ getData.NoticeContent }}</span>
      </p>

      <p class="info_line">
        <span>公告状态：</span>
        <span
          ><p v-if="getData.status == 0" style="color: #ffa200">待发布</p>
          <p v-else-if="getData.status == 1" style="color: #00d299">已发布</p>
          <p v-else-if="getData.status == 2" style="color: #999999">已过期</p>
          <p v-else>未知状态</p></span
        >
      </p>

      <p class="info_line">
        <span>添加时间：</span>
        <span>{{
          getData.CreateTime != null
            ? $moment(getData.CreateTime).format("YYYY/MM/DD HH:mm")
            : null
        }}</span>
      </p>

      <p class="info_line">
        <span>发布者：</span>
        <span>{{ getData.Publisher }}</span>
      </p>
    </div>

    <!-- 步骤操作按钮 -->
    <div class="operation">
      <el-button class="succ_btn" @click="backfor">返回</el-button>
      <el-button type="success" class="submit_btn" @click="nextPage"
        >下一步</el-button
      >
    </div>
  </div>
</template>

<script>
import noticeApi from "@/api/notice";
export default {
  props: ["cutcoms"],
  data() {
    // 校验非空
    var validateIsNull = (rule, value, callback, prefixMsg) => {
      if (value instanceof Array) {
        value = value.join("");
      }
      if (value.split(" ").join("").length === 0) {
        callback(new Error(prefixMsg + "不能为空"));
      } else {
        callback();
      }
    };
    return {
      // 表单全局定义
      labelPosition: "left",
      formLabelAlign: {
        NoticeName: "",
        OpenTime: [],
        NoticeContent: "",
      },
      vehicleTime: "", // 默认时分
      // 表单校验
      rules: {
        NoticeName: [
          { required: true, message: "请输入公告名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "公告名称");
            },
            trigger: "blur",
          },
          { min: 3, message: "长度不能少于 3 个字符", trigger: "blur" },
        ],
        OpenTime: [
          { required: true, message: "请输入公告开放时间", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "公告开放时间");
            },
            trigger: "blur",
          },
        ],
        NoticeContent: [
          { required: true, message: "请输入公告内容", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "公告内容");
            },
            trigger: "blur",
          },
          { min: 3, message: "长度不能少于 3 个字符", trigger: "blur" },
        ],
      },
      // 详细信息
      getData: {},
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
    };
  },
  methods: {
    // 返回
    backfor() {
      this.$parent.backBtn();
      this.$parent.$parent.changes(0);
    },
    // 下一页
    nextPage() {
      const pageType = this.$parent.$parent.$children[0].pageType;
      switch (pageType) {
        case "add":
          // 校验不通过无法进入到下一页
          this.$refs["formLabelAlign"].validate((valid) => {
            if (valid) {
              this.cutcoms(1);
            } else {
              return false;
            }
          });
          break;
        case "edit":
          break;
        case "detail":
          this.cutcoms(1);
          break;
        default:
          this.$message.error("没有找到页面类型");
          return;
      }
    },
    // 基本请求参数工具
    baseReqParamUtils(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    // 页面显示开关
    switchPage() {
      const pageType = this.$parent.$parent.$children[0].pageType;
      switch (pageType) {
        case "add":
          break;
        case "edit":
          break;
        case "detail":
          this.noticePreviews();
          break;
        default:
          this.$message.error("没有找到页面类型");
          return;
      }
    },
    // 点击获取当前默认时间
    obtainTime() {
      let time = new Date(); // 当前时间
      let defaultendtime = new Date(time.getTime() + 1000 * 60 * 30); //开始时间往后延长30分钟。
      this.vehicleTime = this.$moment(time).format("HH:mm:ss");
      console.log(this.vehicleTime, "后半小时");
    },
    // 查看考生列表
    async noticePreviews() {
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.NoticeID = this.$parent.$parent.$children[0].rowData.NoticeID;
      console.log(reqParam, "@@@查看考生列表请求数据");
      const { data } = await noticeApi.noticePreview(reqParam);
      console.log(data, "@@@查看考生列表响应数据");
      if (data.Status == 200) {
        this.getData = data.Data.data;
      } else {
        this.$message.error(data.Data);
      }
    },
  },
  activated() {
    this.switchPage();
  },
};
</script>

<style lang='scss' scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
  border-radius: 4px 4px 4px 4px;
  padding-bottom: 50px;
  margin-top: 24px;
}

// 添加表单css
.el-form {
  display: flex;
  flex-direction: column;
  .el-form-item {
    margin-bottom: 30px;
    ::v-deep .el-form-item__label {
      margin-left: 24px;
      width: 128px !important;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    ::v-deep .el-form-item__content {
      margin-left: 154px !important;
    }
    ::v-deep .el-input__inner {
      height: 40px;
      width: 609px;
      &:hover {
        border: 1px solid #abd7ff;
      }
    }
    ::v-deep .el-textarea > .el-textarea__inner {
      height: 260px;
      width: 609px;
      &:hover {
        border: 1px solid #abd7ff;
      }
    }
  }
}

// 查看详情
.info_box {
  margin-top: 24px;
  .info_line {
    display: flex;
    margin-left: 24px;
    margin-bottom: 30px;
    span:first-child {
      display: inline-block;
      width: 128px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }
    span:nth-child(2) {
      white-space: normal;
      width: 700px;
      display: block;
    }
  }
}

// 步骤操作按钮
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 148px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
</style>